import { useEffect, useState } from "react";
import { useFetcher, useSearchParams } from "react-router-dom";

import { useBeforeEffect } from "@/hooks";

export const useProjectPooling = (
  path,
  project,
  statements,
  startPooling,
  interval = 3000,
) => {
  let [searchParams] = useSearchParams();
  const [updatedProject, setProject] = useState(project);
  const [updatedStatements, setStatements] = useState(statements);
  const fetcher = useFetcher();

  const fetchProject = () => {
    if (!startPooling) return;
    const clone = new URLSearchParams(searchParams.toString());
    clone.set("processed", "false");
    fetcher.load(`${path}?${clone.toString()}`);
  };

  useBeforeEffect(() => {
    setProject(project);
  }, [project]);

  useBeforeEffect(() => {
    setStatements(statements);
  }, [statements]);

  useEffect(() => {
    let intervalId = null;
    if (startPooling) {
      intervalId = setInterval(fetchProject, interval);
    }
    fetchProject();

    return () => {
      clearInterval(intervalId);
    };
  }, [startPooling, searchParams]);

  useEffect(() => {
    if (fetcher.data) {
      setProject(fetcher.data.project);
      setStatements(fetcher.data.projectStatements);
    }
  }, [fetcher.data]);

  return {
    project: updatedProject,
    statements: updatedStatements,
    setProject,
    setStatements,
  };
};
